var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscalamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.272 21.64c-1.843 0-3.33.604-4.46 1.812-1.129 1.208-1.695 2.889-1.695 5.045 0 1.584.117 4.194.352 7.831l1.246 18.661c.234 2.416.623 4.214 1.169 5.396.546 1.181 1.52 1.772 2.922 1.772 1.376 0 2.363-.61 2.961-1.831s.987-2.974 1.169-5.259L55.61 35.86c.182-1.766.272-3.507.272-5.221 0-2.909-.376-5.136-1.13-6.681-.752-1.545-2.245-2.318-4.48-2.318zM49.962 68.975c-1.637 0-3.02.565-4.149 1.695s-1.695 2.5-1.695 4.11c0 1.844.593 3.278 1.773 4.305 1.181 1.026 2.564 1.539 4.149 1.539 1.558 0 2.921-.52 4.09-1.558 1.169-1.039 1.753-2.468 1.753-4.285 0-1.611-.577-2.98-1.732-4.11-1.157-1.131-2.553-1.696-4.189-1.696z",
    fill: "#ff0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.227 4.547C25.248 4.547 5 24.795 5 49.773S25.248 95 50.227 95s45.227-20.249 45.227-45.227C95.453 24.795 75.205 4.547 50.227 4.547zm0 83.604c-21.161 0-38.378-17.216-38.378-38.378s17.217-38.378 38.378-38.378c21.162 0 38.378 17.216 38.378 38.378S71.389 88.151 50.227 88.151z",
    fill: "#ff0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalamation);
export default __webpack_public_path__ + "static/media/escalamation.206889f49b615d38fae09bee9352081d.svg";
export { ForwardRef as ReactComponent };